// extracted by mini-css-extract-plugin
export default {"list":"CatalogGrid_list__VPO5v","catalog":"CatalogGrid_catalog__1FMio"};